export default {
   name: 'Policy',
   data() {
       return {
           showPolicy: true
       }
   },
   methods: {
       setShowPolicy() {
        localStorage.setItem('acc_ret_cookies', true)
        this.showPolicy = false
       }
   },
 
}
